<template>
    <div
      class="m-3 p-5 rounded text-center"
      style="background: #f1f1f1;"
    >
      Debe estar registrado para acceder a esta sección
    </div>
</template>
<script>
export default {
    
}
</script>